import ModelArticle from './ModelArticle';
import { keywordSets } from '../PageSeo';
import heroCamp from '../images/ti7/hero-camp.jpg';
import detailSide from '../images/ti7/detail-side.jpg';
import detailFront from '../images/ti7/detail-front.jpg';
import detailRear from '../images/ti7/detail-rear.jpg';
import interiorDash from '../images/ti7/interior-dash.jpg';
import interiorRow2 from '../images/ti7/interior-row2.jpg';
import v2lCamp from '../images/ti7/v2l-camp.jpg';

export const ti7ArticleMeta = {
  slug: 'byd-ti7-indonesia-suv-7-seater-hybrid',
  title: 'BYD Ti7 Indonesia: SUV 7-Seater DM-p Hybrid 408 PS, Open Pre-Book',
  description:
    'Kenali BYD Ti7, SUV tujuh kursi pertama BYD dengan DM-p Super Hybrid AWD 408 PS, jarak listrik murni 119 km, dan pre-book yang sudah dibuka di BYD Arista BSD City.',
  image: heroCamp,
  contentLength: '1000 kata',
};

const article = {
  slug: ti7ArticleMeta.slug,
  metaTitle: ti7ArticleMeta.title,
  metaDescription: ti7ArticleMeta.description,
  keywords: [
    ...keywordSets.ti7,
    ...keywordSets.localDealer,
    'BYD Ti7 review',
    'BYD Ti7 vs Land Cruiser',
    'SUV hybrid 7 penumpang 2026',
  ],
  datePublished: '2026-11-01',
  heroImage: heroCamp,
  heroAlt: 'BYD Ti7 Jade Green saat berkemah malam hari, SUV 7-seater DM-p',
  eyebrow: 'BYD Ti7 · Open Pre-Book',
  heroTitle: 'BYD Ti7: SUV tujuh kursi pertama BYD, bertenaga 408 PS',
  heroText:
    'Ti7 menggabungkan bodi kotak bergaya off-road, kabin tiga baris untuk tujuh penumpang, dan sistem DM-p Super Hybrid AWD yang bisa berjalan listrik murni hingga 119 km. Pre-book sudah dibuka di BYD Arista BSD City, harga resmi Indonesia menyusul.',
  modelPath: '/jelajahi-ti7',
  modelLabel: 'Lihat halaman BYD Ti7',
  waMessage:
    'Halo Junius, saya baca artikel BYD Ti7 dan ingin pre-book. Mohon info ketentuan tanda jadi, pilihan warna, dan estimasi pengiriman.',
  quickSpecs: [
    { label: 'Tenaga sistem', value: '408 PS' },
    { label: '0-100 km/jam', value: '4,8 detik' },
    { label: 'Jarak listrik murni', value: '119 km WLTP' },
    { label: 'Kursi', value: '7 (3 baris)' },
    { label: 'Baterai', value: 'Blade 35,6 kWh' },
  ],
  sections: [
    {
      title: 'Apa itu BYD Ti7?',
      paragraphs: [
        'BYD Ti7 adalah SUV besar bergaya off-road yang diposisikan BYD sebagai model terbesar dan paling serbaguna di jajarannya. Panjangnya 5.146 mm, lebar 1.995 mm, dan tinggi 1.865 mm, dengan kaca depan tegak, fender melebar, serta ban serep yang menempel di pintu belakang berengsel samping. Dari jauh siluetnya mengingatkan pada SUV petualang klasik, tetapi di baliknya ada teknologi plug-in hybrid terbaru BYD.',
        'Yang membuatnya istimewa untuk keluarga Indonesia adalah tiga baris kursi untuk tujuh penumpang. Ini SUV tujuh kursi pertama BYD. Kursi baris kedua bisa diatur empat arah, baris ketiga bisa dilipat rata ke lantai bagasi, dan kursi depan maupun baris kedua sisi luar dilengkapi penghangat serta ventilasi.',
      ],
    },
    {
      title: 'DM-p Super Hybrid: listrik untuk harian, hybrid untuk perjalanan jauh',
      paragraphs: [
        'Ti7 memakai sistem DM-p Super Hybrid. Mesin bensin 1.5 liter turbo berkekuatan 150 PS dipasang memanjang dan tugas utamanya menghasilkan listrik, sementara motor listrik di depan dan belakang yang menggerakkan roda. Hasilnya penggerak AWD cerdas dengan tenaga sistem 408 PS dan akselerasi 0-100 km/jam hanya 4,8 detik, angka yang biasanya milik mobil sport.',
        'Baterai Blade 35,6 kWh memberi jarak listrik murni hingga 119 km WLTP, bahkan hingga 164 km untuk pemakaian dalam kota. Artinya perjalanan rumah ke kantor di Jabodetabek bisa sepenuhnya listrik tanpa bensin, sedangkan untuk mudik atau liburan ke luar kota mesin bensin menghilangkan kecemasan soal jarak. Pengisian DC dari 30 ke 80 persen memakan waktu sekitar 17,5 menit, dan fitur V2L mengubah Ti7 menjadi sumber listrik saat berkemah atau listrik padam.',
      ],
    },
    {
      title: 'Kabin yang dirancang untuk kenyamanan tujuh orang',
      paragraphs: [
        'Layar sentuh 15,6 inci menjadi pusat kabin, didampingi panel instrumen digital 10,25 inci dan dua wireless charger 50 W. Sistem audio 18 speaker, AC tiga zona, atap kaca panoramik, kaca akustik di bagian depan, dan privacy glass dari pintu belakang ke belakang membuat perjalanan jauh terasa tenang. Di antara pengemudi dan penumpang depan ada kulkas sekaligus penghangat minuman.',
        'Soal bagasi, konfigurasi tujuh kursi menyisakan 126 liter, cukup untuk tas harian. Lipat baris ketiga dan ruangnya menjadi 970 liter, lipat baris kedua juga dan Anda mendapat 1.830 liter, cukup untuk sepeda atau perlengkapan berkemah keluarga.',
      ],
    },
    {
      title: 'Status BYD Ti7 di Indonesia',
      paragraphs: [
        'Pre-book BYD Ti7 resmi dibuka pada 30 Oktober 2026 di BYD Arista BSD City, bersamaan dengan BYD Atto 2. Jaringan dealer BYD Indonesia mengonfirmasi Ti7 hadir sebagai SUV plug-in hybrid DM-p dengan penggerak AWD. Harga OTR Jakarta, pilihan varian, dan spesifikasi final untuk Indonesia belum diumumkan BYD Motor Indonesia, sehingga angka di artikel ini mengacu pada spesifikasi varian Excellence AWD.',
        'Pemesan pre-book mendapat prioritas unit dan penawaran eksklusif, lalu dikabari lebih dulu begitu harga resmi keluar. Ketentuan tanda jadi dan estimasi pengiriman dikonfirmasi langsung oleh Junius.',
      ],
      bullets: [
        'Hubungi Junius lewat WhatsApp dan sebutkan minat pre-book BYD Ti7.',
        'Pilih warna favorit: Jade Green, Starlight Silver, Mountain Green, Titanium Grey, atau Obsidian Black.',
        'Lengkapi tanda jadi sesuai ketentuan dealer, lalu tunggu kabar harga resmi dan jadwal pengiriman.',
      ],
    },
    {
      title: 'Untuk siapa BYD Ti7 cocok?',
      paragraphs: [
        'Ti7 paling masuk akal untuk keluarga besar yang rutin bepergian jauh tetapi ingin menikmati keheningan dan hemat biaya mobil listrik di hari kerja. Ia juga menarik bagi pemilik SUV ladder-frame konvensional yang ingin naik kelas ke teknologi hybrid tanpa kehilangan karakter kokoh dan ground clearance tinggi. Dibanding BYD M6 DM yang merupakan MPV, Ti7 menawarkan tenaga jauh lebih besar, AWD, dan gaya yang lebih tegas.',
      ],
    },
  ],
  specTitle: 'Spesifikasi BYD Ti7 DM-p Excellence AWD',
  specRows: [
    ['Dimensi (P x L x T)', '5.146 x 1.995 x 1.865 mm'],
    ['Konfigurasi kursi', '7 kursi, 3 baris'],
    ['Sistem penggerak', 'DM-p Super Hybrid plug-in, AWD'],
    ['Mesin bensin', '1.5 L turbo, 150 PS'],
    ['Tenaga sistem', '408 PS (sekitar 300 kW)'],
    ['Baterai', 'Blade Battery 35,6 kWh'],
    ['Jarak listrik murni', '119 km WLTP (hingga 164 km kota)'],
    ['Akselerasi 0-100 km/jam', '4,8 detik'],
    ['Kecepatan maksimum', 'Sekitar 190 km/jam'],
    ['Pengisian DC', '30-80% sekitar 17,5 menit'],
    ['Bagasi 7 / 5 / 2 kursi', '126 / 970 / 1.830 L'],
    ['Kapasitas tarik', '2.500 kg'],
    ['Velg', '20 inci alloy'],
    ['Layar', '15,6 inci + instrumen 10,25 inci'],
    ['Audio', '18 speaker'],
  ],
  specNote: 'Spesifikasi varian Excellence AWD. Kelengkapan dan harga untuk Indonesia diumumkan BYD Motor Indonesia saat peluncuran.',
  galleryTitle: 'BYD Ti7 dari berbagai sisi',
  gallery: [
    { src: detailSide, ratio: 125, alt: 'BYD Ti7 tampak samping', title: 'Siluet tiga bagian', text: 'Bodi tegak sepanjang 5,15 meter dengan garis horizontal yang kokoh.' },
    { src: detailFront, ratio: 125, alt: 'BYD Ti7 tampak depan', title: 'Lampu depan LED khas', text: 'Garis cahaya horizontal menyatu ke grille dengan animasi sambutan.' },
    { src: detailRear, ratio: 125, alt: 'BYD Ti7 tampak belakang dengan ban serep', title: 'Ban serep di pintu belakang', text: 'Pintu belakang berengsel samping dan lampu LED lebar.' },
    { src: interiorDash, ratio: 56, alt: 'Dashboard BYD Ti7 dengan layar 15,6 inci', title: 'Kokpit terhubung', text: 'Layar 15,6 inci, instrumen digital, dan dual wireless charging.' },
    { src: interiorRow2, ratio: 56, alt: 'Kursi baris kedua BYD Ti7', title: 'Baris kedua lega', text: 'Kursi atur 4 arah dengan penghangat dan ventilasi di sisi luar.' },
    { src: v2lCamp, ratio: 56, alt: 'BYD Ti7 menyalakan perlengkapan kemah lewat V2L', title: 'V2L untuk berkemah', text: 'Ti7 menjadi sumber listrik untuk aktivitas luar ruang.' },
  ],
  faqs: [
    {
      q: 'Apakah BYD Ti7 mobil listrik atau hybrid?',
      a: 'Ti7 adalah plug-in hybrid dengan sistem DM-p Super Hybrid. Ia bisa berjalan listrik murni hingga 119 km WLTP, dan mesin bensin 1.5 turbo mengambil alih sebagai pembangkit listrik saat baterai menipis.',
    },
    {
      q: 'Benarkah BYD Ti7 punya tujuh kursi?',
      a: 'Benar. Ti7 adalah SUV tujuh kursi pertama BYD dengan tiga baris kursi. Baris ketiga bisa dilipat rata untuk memperluas bagasi hingga 970 liter.',
    },
    {
      q: 'Berapa harga BYD Ti7 di Indonesia?',
      a: 'Harga OTR resmi belum diumumkan BYD Motor Indonesia. Pre-book sudah dibuka di BYD Arista BSD City dan pemesan awal akan dikabari lebih dulu begitu harga keluar.',
    },
    {
      q: 'Bagaimana cara pre-book BYD Ti7 di BSD Serpong?',
      a: 'Hubungi Junius lewat WhatsApp. Anda akan mendapat ketentuan tanda jadi, pilihan warna, estimasi pengiriman, dan penawaran eksklusif untuk pemesan awal.',
    },
    {
      q: 'Apa bedanya BYD Ti7 dengan BYD M6 DM?',
      a: 'M6 DM adalah MPV plug-in hybrid untuk keluarga dengan harga lebih terjangkau. Ti7 adalah SUV bergaya off-road dengan AWD, tenaga 408 PS, ground clearance tinggi, dan kabin yang lebih mewah.',
    },
  ],
  related: [
    { label: 'Halaman model BYD Ti7: warna, interior, dan spesifikasi', to: '/jelajahi-ti7' },
    { label: 'BYD Atto 2 Indonesia: SUV kompak listrik, open pre-book', to: '/blog/byd-atto-2-indonesia-pre-book' },
    { label: 'BYD M6 DM Indonesia 2026: MPV plug-in hybrid mulai Rp298 juta', to: '/blog/byd-m6-dm-indonesia' },
    { label: 'Daftar harga BYD dan Danza terbaru', to: '/pricing' },
  ],
  ctaTitle: 'Amankan BYD Ti7 Anda lebih awal',
  ctaText:
    'Pre-book BYD Ti7 sudah dibuka di BYD Arista BSD City. Hubungi Junius untuk ketentuan tanda jadi, pilihan warna, dan penawaran eksklusif pemesan pertama.',
};

function Ti7Article() {
  return <ModelArticle article={article} />;
}

export default Ti7Article;
